import type { ErrorResponse, HttpResponse } from '../api';

export const downloadAsFile = (
  data: Blob,
  filename: string,
  mime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
): void => {
  const file = new Blob([data], { type: mime });
  const a = document.createElement('a'),
    url = URL.createObjectURL(file);
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(function () {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 0);
};

export const getFileName = (disposition: string): string | null => {
  const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-\.]+)(?:; ?|$)/i;
  const asciiFilenameRegex = /filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;

  let fileName: string | null = null;
  if (utf8FilenameRegex.test(disposition)) {
    fileName = decodeURIComponent(utf8FilenameRegex.exec(disposition)?.[1] ?? '');
  } else {
    const matches = asciiFilenameRegex.exec(disposition);
    if (matches != null && matches[2]) {
      fileName = matches[2];
    }
  }
  return fileName;
};

interface IDownloadCustomFile {
  response: HttpResponse<unknown, ErrorResponse | null>;
  downloadedFileName: string;
  match: RegExp;
  mime?: string;
}

export const downloadCustomFile = async ({
  response,
  downloadedFileName,
  match,
  mime,
}: IDownloadCustomFile): Promise<void> => {
  const contentDisposition = response.headers.get('Content-Disposition');
  const fileNameAry = contentDisposition ? contentDisposition.match(match) : null;
  const fileName = fileNameAry ? decodeURIComponent(fileNameAry[1]) : downloadedFileName;
  const blob = await response.blob();
  downloadAsFile(blob, fileName, mime);
};

export const downloadStringViaBase64 = async ({
  value,
  fileName,
  mime = 'text/plain',
}: {
  value?: string;
  fileName: string;
  mime?: string;
}): Promise<void> => {
  const base64 = window.btoa(unescape(encodeURIComponent(value ?? '')));
  const res: Response = await fetch(`data:.;base64,${base64}`);
  const blob: Blob = await res.blob();
  downloadAsFile(blob, fileName, mime);
};

export const openXmlFile = ({
  value,
  mime = 'application/xml',
}: {
  value: string;
  mime?: DOMParserSupportedType;
}): void => {
  const blob = new Blob([value], { type: mime });
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
};
